import { render, staticRenderFns } from "./Import2.vue?vue&type=template&id=5003ce2c&scoped=true"
import script from "./Import2.vue?vue&type=script&lang=js"
export * from "./Import2.vue?vue&type=script&lang=js"
import style0 from "./Import2.vue?vue&type=style&index=0&id=5003ce2c&prod&scoped=true&lang=css"
import style1 from "./Import2.vue?vue&type=style&index=1&id=5003ce2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003ce2c",
  null
  
)

export default component.exports